import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const isInitialRender = useRef(true);

  const focusElement = (element) => {
    if (!element || typeof element.focus !== "function") {
      return;
    }

    window.requestAnimationFrame(() => {
      try {
        element.focus({ preventScroll: true });
      } catch {
        element.focus();
      }
    });
  };

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));

      if (element) {
        isInitialRender.current = false;
        window.requestAnimationFrame(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          focusElement(element);
        });
        return;
      }
    }

    window.scrollTo(0, 0);

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    focusElement(document.getElementById("main-content"));
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
